module.exports = __webpack_public_path__ + "img/btn-quero-me-inscrever-mobile.80ec41e5.svg";